<template>
  <div>
    <report-header
        @filterChanged="filterChanged"
        :filterOptions="filterOptions"
        @paginationChanged="paginationChanged"
        @onChangeAccsGroup="onChangeAccsGroup"
        @onChangedGroup="onChangedGroup"
        @limitChanged="limitChanged"
        @download="download"
        @generate="load"/>

    <basic-table
      v-if="telNumItems"
      :items="telNumItems"
      :fields="telNumFields"
      :filter="filter"
      :perPage="perPage"
      :currentPage="currentPage"
      v-model="totalRows"/>
    <table-manager-bottom
    :totalRows="totalRows" :perPage="perPage"
    v-model="currentPage" />
  </div>
</template>

<script>
import download from '@/utils/downloadFile'
export default {
  data () {
    return {
      options: {
        isShowAddButton: false
      },
      filterOptions: {
        isGenereteButtonDisabled: false,
        isTimeSpanDisabled: true,
        isDataRangeDisabled: true,
        isFilterGroup: true,
        isFilterAccsGroup: true,
        isFilterTypeTraffic: false,
        isFilterTypeDocuments: false,
        isFilterTypeUsers: false,
        isFilterCollector: false,
        isDownloadable: true,
        isActions: false,
        isNotLimit: false,
        isTelephonyReport: false
      },
      fetchParams: {
        group_id: 0,
        accs_group_id: 0,
        limit: 500,
        download: 0
      },
      filter: null,
      perPage: 20,
      totalRows: 0,
      currentPage: 1,
      telNumItems: [],

      telNumFields: [
        {key: 'num_id', label: 'ID', sortable: true},
        {key: 'slink_id', label: this.$i18n.t('ID slink'), sortable: true},
        {key: 'account_id', label: this.$i18n.t('Account ID'), sortable: true},
        {key: 'login', label: this.$i18n.t('Login'), sortable: true},
        {key: 'number', label: this.$i18n.t('Telephone'), sortable: true},
        {key: 'incoming_trunk', label: this.$i18n.t('Incoming trunc'), sortable: true},
        {key: 'outgoing_trunk', label: this.$i18n.t('Outgoing trunc'), sortable: true},
        {key: 'pbx_id', label: this.$i18n.t('PBX ID'), sortable: true},
        {key: 'allowed_cid', label: this.$i18n.t('Allowed CID'), sortable: true},
        {key: 'comment', label: this.$i18n.t('Comment'), sortable: true}
      ]
    }
  },
  methods: {
    onChangedGroup (val) {
      this.fetchParams.group_id = Number(val)
    },
    onChangeAccsGroup (val) {
      this.fetchParams.accs_group_id = Number(val)
    },
    limitChanged (limit) {
      this.fetchParams.limit = limit
    },
    async download () {
      let params = JSON.parse(JSON.stringify(this.fetchParams))
      params.download = 1
      await this.$store.dispatch('Reports/GET_TELEPHONY_NUMBERS', params).then(resp => {
        download(this.$store.getters['Reports/TELEPHONY_NUMBERS'], 'tel_numbers.csv', 'text/csv')
      })
    },
    filterChanged (value) {
      this.filter = value
    },
    paginationChanged (value) {
      this.perPage = value
    },
    async load () {
      await this.$store.dispatch('Reports/GET_TELEPHONY_NUMBERS', this.fetchParams).then(resp => {
        this.telNumItems = this.$store.getters['Reports/TELEPHONY_NUMBERS']
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/users/telephoneNum/main.vue